// extracted by mini-css-extract-plugin
export default {"container":"BackToPage-module__container__Wcw1","backToPageLink":"BackToPage-module__backToPageLink_I9Sj4"};